import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import { useTheme, makeStyles } from "@material-ui/core/styles";
import {
    Box,
    Container,
    Grid,
    Card,
    CardMedia,
    CardHeader,
    CardActionArea,
    CardContent,
    Typography,
    Input,
    NativeSelect,
    TextField,
} from "@material-ui/core";
import "./POIList.css";

import actions from "../actions";


const useStyles = makeStyles({
    root: {
        overflowY: 'scroll',
        maxHeight: '90vh',
    },
});

const fetcher = url => fetch(url).then(r => r.json());
const sendCollectData = (data) => {
    const COLLECT_API_URL = 'https://analytics.sto-tek.com/_nodered/api/statistic/pathPlan';
    const reqOption = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
        },
        body: JSON.stringify(data),
    }
    fetch(COLLECT_API_URL, reqOption);
}

const findStartPoint = (kiosk_poi_id, floorData) => {
    var startPoint = {
        PosX: 0.0,
        PosY: 0.0,
        map_id: undefined,
        poi_name: 'QRcode入口',
    };
    var targetMapId = undefined;
    var targetFloorName = "";
    var targetPoi = undefined;
    const findPoiDetail = (kiosk_poi_id, floorData) => {
        if (
            floorData.find((element) => {
                return parseInt(element.id) === kiosk_poi_id;
            })
        ) {
            return true;
        }
        return false;
    };
    const targetFloor = floorData.find((floor) => {
        return findPoiDetail(kiosk_poi_id, floor.PoiDetail);
    });
    if (targetFloor) {
        targetMapId = parseInt(targetFloor.MapID);
        targetFloorName = targetFloor.Name;
        targetPoi = targetFloor.PoiDetail.find((element) => {
            return parseInt(element.id) === kiosk_poi_id;
        });
        startPoint = {
            PosX: targetPoi.PosX,
            PosY: targetPoi.PosY,
            map_id: targetMapId,
            poi_name: targetPoi.name,
            floorName: targetFloorName,
        };
    }
    return startPoint;
};

function POIList(props) {
    const { data, getFunc, kiosk_id } = props;
    const classes = useStyles();
    const [searchText, setSearchText] = useState('');
    const [poiType, setPoiType] = useState(-1);
    const [poiFloor, setPoiFloor] = useState('');
    const history = useHistory();
    const location = useLocation();

    /* 抓出全樓層 POI 過濾 type 為 1 2 的 */
    var poi_list = data.map((pois, idx) => {
        return pois.PoiDetail.filter(poi => {
            var match = true
            if (poi.typeID === 6 || poi.typeID === 5) match = false; /* 排除定位點及停車格 */
            if (!poi.PosX || !poi.PosY) match = match && false;
            if (poiType >= 0) {
                console.log(poi.typeID, poiType, poi.typeID === poiType)
                match = match && (poi.typeID === poiType);
            }
            if (poiFloor !== '') {
                console.log(poiFloor, data[idx].Name);
                match = match && (data[idx].Name === poiFloor);
            }
            if (searchText.length > 0) {
                var poi_name = poi.name.toLowerCase();
                var poi_engname = poi.nameEnglish.toLowerCase();
                var search_text = searchText.toLowerCase();
                var poi_number = poi.number.toLowerCase();
                var name_match = (poi_name.includes(search_text) || poi_engname.includes(search_text));
                var number_match = poi_number.includes(search_text);
                match = match && (name_match || number_match);
            }
            return match;
        }).map(poi => {
            return {
                ...poi,
                map_id: data[idx].MapID,
                floor_name: data[idx].Name,
            }
        })
    }).flat();
    /* 抓出全樓層來產生樓層選擇的選項 */
    var floor_list = data.map((pois, idx) => {
        return {
            name: pois.Name,
            value: idx + 1,
        }
    });
    console.log(floor_list);

    const naviSTART = findStartPoint(kiosk_id, data);
    const handleSearch = (e) => {
        setSearchText(e.target.value);
    }
    const handleSelect = (e) => {
        setPoiType(parseInt(e.target.value, 10));
    }
    const handleSelectFloor = (e) => {
        setPoiFloor(e.target.value);
    }
    const handleClick = (poi) => {
        const pointData = {
            startX: naviSTART.PosX,
            startY: naviSTART.PosY,
            startZ: naviSTART.map_id,
            startFloor: naviSTART.floorName, //
            endX: poi.PosX,
            endY: poi.PosY,
            endZ: poi.map_id,
            endFloor: poi.floor_name,
        };
        const collectData = {
            apikey: getFunc.apikey,
            start_poi_id: kiosk_id,
            start_poi_name: naviSTART.poi_name,
            start_x: naviSTART.PosX,
            start_y: naviSTART.PosY,
            start_map: naviSTART.map_id,
            end_poi_id: poi.id,
            end_poi_name: poi.name,
            end_x: poi.PosX,
            end_y: poi.PosY,
            end_map: poi.floor_name,
        };
        sendCollectData(collectData);
        history.push("/MapView", {
            ...location.state,
            pointData,
            carInfo: poi,
        });
    }

    return (
        <Container>
            <Box alignItems="center" >
                <Grid container spacing={2} justifyContent="center" alignItems="center" my={3}>
                    <Grid item xs={6}>
                        <Input
                            id="poi_search"
                            color="primary"
                            placeholder="搜尋文字"
                            value={searchText}
                            onChange={handleSearch}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <NativeSelect
                            id="selectType"
                            value={poiType}
                            onChange={handleSelect}
                        >
                            <option value={-1} >類型</option>
                            <option value={1} >公共設施</option>
                            <option value={2} >商家櫃位</option>
                        </NativeSelect>
                    </Grid>
                    <Grid item xs={3}>
                        <NativeSelect
                            id="selectFloor"
                            value={poiFloor}
                            onChange={handleSelectFloor}
                        >
                            <option value='' >樓層</option>
                            {floor_list.map(floor => {
                                return (
                                    <option key={'opt-' + floor.name} value={floor.name}>{floor.name}</option>
                                )
                            })}
                        </NativeSelect>
                    </Grid>
                </Grid>
            </Box>
            <Grid container
                spacing={2}
                justifyContent="center"
                alignItems="center"
                m="auto"
                className={classes.root}
            >
                {poi_list.map(poi => {
                    return <Grid item key={poi.id} md={6}>
                        <Card >
                            <CardActionArea
                                onClick={() => handleClick(poi)}
                            >
                                {/* <CardHeader title={poi.name} subheader={poi.floor_name} /> */}
                                <CardMedia component="img" image={poi.url} height="auto" width="auto" />
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="div">
                                        {poi.name}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {poi.floor_name}
                                    </Typography>
                                    <Typography>
                                        {poi.number}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                })}
            </Grid>
        </Container>
    )
}

export default POIList;
